export default __webpack_public_path__ + "static/media/TL04.1.6f5310f0.mp3";